<template>
  <div style="width: 100%; text-align: center;" v-if="dados.anais_cor_bg_menus == null || dados.anais_cor_bg_menus == '' || !dados.anais_cor_bg_menus">
    <table width="100%" border="0">
      <tr>
        <td width="20%" class="button-row">
          <router-link to="/" class="button-content">
            {{ $t('inicio') | capitalize }}
            <br/>
            <i class="fa fa-home"></i>
          </router-link>
        </td>
        <td width="20%" class="button-row">
          <router-link to="/corpo_editorial" class="button-content">
            {{ $t('corpo_editorial') }}
            <br/>
            <i class="fa fa-book"></i>
          </router-link>
        </td>
        <td width="20%" class="button-row">
          <router-link to="/autores" class="button-content">
            {{ $tc('autor', 2) | capitalize}}
            <br/>
            <i class="fa fa-users"></i>
          </router-link>
        </td>
        <td width="20%" class="button-row">
          <router-link to="/eixos" class="button-content">
            {{ $tc('eixo', 2) | capitalize }}
            <br/>
            <i class="fa fa-plus"></i>
          </router-link>
        </td>
        <td width="20%" class="button-row">
          <router-link to="/trabalhos" class="button-content">
            {{ $tc('trabalho', 2) | capitalize }}
            <br/>
            <i class="fa fa-pencil"></i>
          </router-link>
        </td>
      </tr>
    </table>
  </div>

  <div class='col-md-12' v-else>
    <router-link to="/" class="button-content-new col-md-2" :style="{background: dados.anais_cor_bg_menus, border:dados.anais_cor_bg_menus + ' solid 1px', color: dados.anais_cor_fonte_menus}">
      {{ $t('inicio') | capitalize }}
    </router-link>

    <router-link to="/corpo_editorial" class="button-content-new col-md-2" :style="{background: dados.anais_cor_bg_menus, border:dados.anais_cor_bg_menus + ' solid 1px', color: dados.anais_cor_fonte_menus}">
      {{ $t('corpo_editorial') | capitalize }}
    </router-link>

    <router-link to="/autores" class="button-content-new col-md-2" :style="{background: dados.anais_cor_bg_menus, border:dados.anais_cor_bg_menus + ' solid 1px', color: dados.anais_cor_fonte_menus}">
      {{ $tc('autor', 2) | capitalize }}
    </router-link>

    <router-link to="/eixos" class="button-content-new col-md-2" :style="{background: dados.anais_cor_bg_menus, border:dados.anais_cor_bg_menus + ' solid 1px', color: dados.anais_cor_fonte_menus}">
      {{ $tc('eixo', 2) | capitalize }}
    </router-link>

    <router-link to="/trabalhos" class="button-content-new col-md-2" :style="{background: dados.anais_cor_bg_menus, border:dados.anais_cor_bg_menus + ' solid 1px', color: dados.anais_cor_fonte_menus}">
      {{ $tc('trabalho', 2) | capitalize }}
    </router-link>

  </div>
</template>

<script>
  import { i18n } from '@/langs/anais'

  export default {

    name: 'AnaisHeader',

    i18n: i18n,

    data () {
      return {
        dados: {
          anais_cor_bg_menus: null,
          template: null
        }
      }
    },

    components: {},

    props:[],

    watch:{},

    mounted () {

      Promise.all([
        this.$http.post(window.url + "admin/api", {
          type: "getAnaisInfo"
        })
      ])
      .catch((err) => {
        console.log(err);
      })
      .then((responses)=>{
        let responsePromises = []
        for(let response of responses){
          responsePromises.push(response.json())
        }
        return Promise.all(responsePromises)
      }).then((responses)=>{

        this.dados = responses[0];

      })

    }
  }
</script>

<style v-if="dados.template != 'oreen'">
  .button-content-new {
    text-align:center !important;
    border-radius:10px !important;
    padding:10px !important;
    font-weight:bolder !important;
    font-size:16px !important;
    text-transform:uppercase !important;
    margin-right:10px !important;
    width: 19% !important;
    margin-bottom:30px !important;
  }
</style>

<style v-else>
  .button-content-new {
    text-align:center !important;
    border-radius:10px !important;
    padding:10px 5px !important;
    font-weight:bolder !important;
    font-size:16px !important;
    text-transform:uppercase !important;
    margin-right:5px !important;
    width: 19% !important;
    margin-bottom:30px !important;
  }
</style>

<style scoped>
.button-row {
    padding: 20px;
}
.button-content {
    text-align: center;
    box-shadow: 0px 3px 0px #B7453C;
    border-radius: 8px;
    display: inline-block;
    width: 100%;
    color: black;
}
.button-content:hover {
    text-decoration: unset;
    box-shadow: 0px 0px 3px 3px #B7453C;
    transition: 0.2s;
}
</style>


// WEBPACK FOOTER //
// AnaisHeader.vue?7b382946